import { IonicModalService } from './modal.service';

export default angular
  .module('sfMobile.services.modal', ['ionic'])
  .service('modalService', IonicModalService).name;
